import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSubscriptionsQueryVariables = Types.Exact<{
  getSubscriptionInput: Types.GetSubscriptionsInput;
}>;

export type GetSubscriptionsQuery = {
  __typename?: "Query";
  getSubscriptions: {
    __typename?: "SubscriptionsPaginatedResponse";
    subscriptions: Array<{
      __typename?: "Subscription";
      subscriptionUuid: string;
      plan: string;
      startDate: string;
      endDate: string | null;
      status: string;
      active: boolean;
      isEligibleForBooking: boolean | null;
      planObject: {
        __typename?: "SubscriptionPlanSimple";
        uuid: string;
        name: string;
        allowCheckins: boolean;
      };
      warningMessage: {
        __typename?: "WarningMessage";
        title: string | null;
        content: string | null;
      } | null;
    }> | null;
  };
};

export type SubscriptionsPaginatedResponseSubscriptionControllerOptionFragment =
  {
    __typename?: "SubscriptionsPaginatedResponse";
    subscriptions: Array<{
      __typename?: "Subscription";
      subscriptionUuid: string;
      plan: string;
      startDate: string;
      endDate: string | null;
      status: string;
      active: boolean;
      isEligibleForBooking: boolean | null;
      planObject: {
        __typename?: "SubscriptionPlanSimple";
        uuid: string;
        name: string;
        allowCheckins: boolean;
      };
      warningMessage: {
        __typename?: "WarningMessage";
        title: string | null;
        content: string | null;
      } | null;
    }> | null;
  };

export type SubscriptionOptionFragment = {
  __typename?: "Subscription";
  subscriptionUuid: string;
  plan: string;
  startDate: string;
  endDate: string | null;
  status: string;
  active: boolean;
  isEligibleForBooking: boolean | null;
  planObject: {
    __typename?: "SubscriptionPlanSimple";
    uuid: string;
    name: string;
    allowCheckins: boolean;
  };
  warningMessage: {
    __typename?: "WarningMessage";
    title: string | null;
    content: string | null;
  } | null;
};

export const SubscriptionOptionFragmentDoc = gql`
  fragment SubscriptionOption on Subscription {
    subscriptionUuid
    plan
    startDate
    endDate
    status
    active
    isEligibleForBooking
    planObject {
      uuid
      name
      allowCheckins
    }
    warningMessage {
      title
      content
    }
  }
`;
export const SubscriptionsPaginatedResponseSubscriptionControllerOptionFragmentDoc = gql`
  fragment SubscriptionsPaginatedResponseSubscriptionControllerOption on SubscriptionsPaginatedResponse {
    subscriptions {
      ...SubscriptionOption
    }
  }
  ${SubscriptionOptionFragmentDoc}
`;
export const GetSubscriptionsDocument = gql`
  query GetSubscriptions($getSubscriptionInput: GetSubscriptionsInput!) {
    getSubscriptions(getSubscriptionInput: $getSubscriptionInput) {
      ...SubscriptionsPaginatedResponseSubscriptionControllerOption
    }
  }
  ${SubscriptionsPaginatedResponseSubscriptionControllerOptionFragmentDoc}
`;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      getSubscriptionInput: // value for 'getSubscriptionInput'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionsQuery,
    GetSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(
    GetSubscriptionsDocument,
    options,
  );
}
export function useGetSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionsQuery,
    GetSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionsQuery,
    GetSubscriptionsQueryVariables
  >(GetSubscriptionsDocument, options);
}
export type GetSubscriptionsQueryHookResult = ReturnType<
  typeof useGetSubscriptionsQuery
>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionsLazyQuery
>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<
  GetSubscriptionsQuery,
  GetSubscriptionsQueryVariables
>;
